let resolveLanguage: (() => string) | undefined;

export function setApiLanguageResolver(resolver: (() => string) | undefined) {
    resolveLanguage = resolver;
}

export function getApiLanguage() {
    return resolveLanguage?.();
}
